// Como um cliente do calculator-api é nomeado na tela de consumo.
//
// O nome sozinho não identifica: nomes duplicados são aceitos na criação, e quem
// olha consumo conhece o cliente pelo ID da Jusfy — que é justamente o que o
// objeto do calculator-api chama de `backendClientId`.
//
// `null` não vira célula vazia: é cliente interno do calculator-api ou cliente
// desvinculado, e os dois existem de verdade na lista desde que a rota parou de
// filtrar por vínculo.
export const clientLabelOf = ({ name, backendClientId }) =>
  backendClientId === null || backendClientId === undefined
    ? `${name} — sem vínculo`
    : `${name} — Jusfy ${backendClientId}`;
